import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Menu from "@/views/Menu.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/login" },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
  },
  // {
  //   path: "/notice",
  //   name: "notice",
  //   children: [
  //     {
  //       path: "/index",
  //       name: "index",
  //       component: () => import("@/views/notice/index.vue"),
  //     }
  //   ]
  // },
  {
    path:'/page',
    component: Menu,
      children:[
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/index.vue"),
      },
      {
        path: "/notice",
        name: 'notice',
        component: () => import("@/views/notice/index.vue"),
      },
      {
        path: "/notice/detail",
        name: 'noticeDetail',
        component: () => import("@/views/notice/detail.vue"),
      },
      {
        path: "/myTrain",
        name: "myTrain",
        component: () => import("@/views/myTrain/index.vue"),
      },
      {
        path: "/courseList",
        name: "courseList",
        component: () => import("@/views/courseList.vue"),
      },
      {
        path: "/specialList",
        name: "specialList",
        component: () => import("@/views/specialList.vue"),
      },
      {
        path: "/live/index",
        name: "liveList",
        component: () => import("@/views/live/index.vue"),
      },
      {
        path: "/live/detail",
        name: "liveDetail",
        component: () => import("@/views/live/detail.vue"),
      },
      {
        path: "/myTrain/detail",
        name: "myTrainDetail",
        component: () => import("@/views/myTrain/detail.vue"),
      },
      {
        path: "/myTrain/course",
        name: "myTrainCourse",
        component: () => import("@/views/myTrain/course.vue"),
      },
      {
        path: "/selfStudy",
        name: "selfStudy",
        component: () => import("@/views/selfStudy.vue"),
      },
      {
        path: "/myTest",
        name: "myTest",
        component: () => import("@/views/myTest.vue"),
        redirect: "/myTest/myPaperList",
        children: [
          {
            path: "/myTest/myPaperList",
            name: "myPaperList",
            component: () => import("@/views/myTest/paperList.vue"),
            
          },
          
          {
            path: "/myTest/myZcList",
            name: "myZcList",
            component: () => import("@/views/myTest/zcList.vue"),
          },
          {
            path: "/myTest/myCtList",
            name: "myCtList",
            component: () => import("@/views/myTest/ctList.vue"),
          },
        ],
      },
      {
        path: "/studyTime",
        name: "studyTime",
        component: () => import("@/views/studyTime.vue"),
        redirect: "/studyTime/network",
        children: [
          {
            path: "/studyTime/network",
            name: "network",
            component: () => import("@/views/studyTime/network.vue"),
            
          },
          {
            path: "/studyTime/networkCourse",
            name: "networkCourse",
            component: () => import("@/views/studyTime/networkCourse.vue"),
            
          },
          
          {
            path: "/studyTime/supplement",
            name: "supplement",
            component: () => import("@/views/studyTime/supplement.vue"),
          },
          
        ],
      },
      {
        path: "/userInfo",
        name: "userInfo",
        component: () => import("@/views/userInfo.vue"),
        redirect: "/userInfo/user",
        children: [
          {
            path: "/userInfo/user",
            name: "user",
            component: () => import("@/views/userInfo/user.vue"),
            
          },
          
          {
            path: "/userInfo/cert",
            name: "cert",
            component: () => import("@/views/userInfo/cert.vue"),
          },
          
        ],
      },
      {
        path: "/myTest/myPaperList/myPaperView",
        name: "myPaperView",
        component: () => import("@/views/myTest/paperView.vue"),
      },
      {
        path: "/myTest/myPaperList/myPaper",
        name: "myPaper",
        component: () => import("@/views/myTest/paper.vue"),
      },
      {
        path: "/myTest/myPaperList/doQues",
        name: "doQues",
        component: () => import("@/views/myTest/doQues.vue"),
      },
    ]
  }
];

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== "login" && !store.state.isLogin) {
    if (
      to.name === "AppDownload" 
    ) {
      next();
    } else {
      next("login");
    }
  } else {
    next();
  }
});

export default router;
